
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  components: {},
})
export default class EditEmailModal extends Vue {
  @Prop({ default: false })
  show!: boolean;

  @Prop({ default: '' })
  currentEmail!: string;

  @Prop({ default: false })
  loading!: boolean;

  @Prop({ default: false })
  showSuccessBanner!: boolean;

  newEmail = '';
  emailError = '';

  @Watch('show')
  onShowChange(newVal: boolean) {
    if (newVal) {
      this.resetForm();
    }
  }

  resetForm() {
    this.newEmail = '';
    this.emailError = '';
  }

  validateEmail() {
    this.emailError = '';
    
    if (!this.newEmail) {
      return;
    }

    // Check for @ sign
    if (!this.newEmail.includes('@')) {
      this.emailError = 'Email must contain @ symbol';
      return;
    }

    // Check for allowed characters (alphanumeric, @, ., -, _, +)
    const emailRegex = /^[a-zA-Z0-9@._+-]+$/;
    if (!emailRegex.test(this.newEmail)) {
      this.emailError = 'Email contains invalid characters. Only letters, numbers, @, ., -, +, and _ are allowed';
      return;
    }

    // Basic email format validation
    const emailFormatRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailFormatRegex.test(this.newEmail)) {
      this.emailError = 'Please enter a valid email format';
      return;
    }

    // Check if new email is different from current
    if (this.newEmail === this.currentEmail) {
      this.emailError = 'New email must be different from current email';
      return;
    }
  }

  handleCancel() {
    this.$emit('cancel');
  }

  async handleSave() {
    this.validateEmail();
    
    if (this.emailError !== '') {
      return;
    }

    // Show confirmation dialog
    const confirmed = await this.showConfirmationDialog(
      `Are you sure you want to change the login email of this user?`,
      'Yes, change email',
      'Cancel'
    );

    if (confirmed) {
      this.$emit('save', {
        currentEmail: this.currentEmail,
        newEmail: this.newEmail.toLowerCase()
      });
    }
  }

  private showConfirmationDialog(message: string, confirmText: string, cancelText: string): Promise<boolean> {
    return new Promise((resolve) => {
      const result = confirm(message);
      resolve(result);
    });
  }
}
